import { render, staticRenderFns } from "./BarChartProdutividade.vue?vue&type=template&id=08de594f"
import script from "./BarChartProdutividade.vue?vue&type=script&lang=js"
export * from "./BarChartProdutividade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports